import script from "./ProfileConfirmView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileConfirmView.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileConfirmView.vue?vue&type=style&index=0&id=583b0947&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-583b0947"]])

export default __exports__